import { template, blocks, anodum, nanoid } from '@yola/ws-sdk';
import store from 'src/js/store';
import getAllBlocksForTarget from '../../blocks/helpers/get-all-blocks-for-target';
import assignGroupId from '../../extensions/common/helpers/assign-group-id';

function sortBlocksByCategory(allBlocks, categories) {
  const order = Object.fromEntries(
    categories.map(({ name: categoryName }, index) => [categoryName, index])
  );
  return [...allBlocks].sort(
    (a, b) => (order[a.category] ?? Infinity) - (order[b.category] ?? Infinity)
  );
}

function assignUniqueContactFieldIds(element) {
  element
    .querySelectorAll(
      'ws-contact-form-container input, ws-contact-form-container select, ws-contact-form-container textarea'
    )
    .forEach((field) => {
      const previousId = field.getAttribute('id');
      const nextId = nanoid();
      field.setAttribute('id', nextId);

      if (!previousId) return;

      const label = element.querySelector(`[for="${previousId}"]`);
      if (label) {
        label.setAttribute('for', nextId);
      }
    });
}

const insertAllBlocksToThePage = (featureFlags) => (targetDocument) => {
  const state = store.getState();
  const categories = blocks.selectors.getCategories(state);
  const pageContainerSelector = template.selectors.getPageContainerSelector(state);
  const pageContainer = targetDocument.querySelector(pageContainerSelector);
  const allBlocks = getAllBlocksForTarget({
    targetElement: pageContainer.cloneNode(false),
    featureFlags,
  });

  pageContainer
    .querySelectorAll(`[id^='${blocks.constants.BLOCK_ID_PREFIX}']`)
    .forEach((element) => {
      element.remove();
    });

  sortBlocksByCategory(allBlocks, categories).forEach((block) => {
    const element = anodum.parseElementFromString(block.html);
    element.id = blocks.helpers.generateBlockId(block.id);
    element.setAttribute(blocks.attributes.VARIATION_ATTRIBUTE_NAME, block.variationId);
    assignGroupId({
      container: element,
      querySelector: 'ws-media-container',
      groupAttribute: 'media-group-id',
    });
    assignGroupId({
      container: element,
      querySelector: 'ws-icon',
      groupAttribute: 'icon-group-id',
    });
    assignUniqueContactFieldIds(element);
    pageContainer.insertAdjacentElement('beforeend', element);
  });
};

export default insertAllBlocksToThePage;
